import styled from 'styled-components';

export default styled.div`
	--person-line1-text-color: var(--body--color);
	display: grid;
	grid-template-columns: 1fr var(--px-200) var(--px-36);
	gap: var(--spacing-small);
	flex: 1;
	align-items: center;
`;
